import BaseTextField from "../../../../components/ui/BaseTextField";
import { useDispatch, useSelector } from "react-redux";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";

const FTHPay = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.workOrder.payment.pay);

  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation
  );
  const handleChange = (event) => {
    const { name, value } = event.target;
    const parsedValue = parseFloat(value);
    dispatch(
      updateWorkOrderForm({
        step: "payment",
        data: {
          pay: {
            [name]: value,
          },
        },
      })
    );

    if (name === "fthRate" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fthRate",
          data: false,
        })
      );
    }
    if (name === "hourlyRate" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "hourlyRate",
          data: false,
        })
      );
    }
    if (name === "fthRate" && (!value || parsedValue <= 0)) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fthRate",
          data: true,
        })
      );
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fthRateErrorMsg",
          data: "First Two Hours Rate is required",
        })
      );
    }
    if (name === "hourlyRate" && (!value || parsedValue <= 0)) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "hourlyRate",
          data: true,
        })
      );
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "hourlyRateErrorMsg",
          data: "Additional hour rate is required",
        })
      );
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-4 mt-3">
      <div className="mr-10">
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.fthRate}
          errorMsg={workOrderFormValidation.fthRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="fthRate"
          name="fthRate"
          label="First two hours"
          requirement="required"
          labelShrink={false}
          value={payment.fthRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
      </div>
      <div>
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.hourlyRate}
          errorMsg={workOrderFormValidation.hourlyRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="hourlyRate"
          name="hourlyRate"
          label="Additional Hour Rate"
          requirement="required"
          labelShrink={false}
          value={payment.hourlyRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
        <p className="mt-2 text-sm text-right">
          Additional hourly rates will be appoicable after first 2 hours
        </p>
      </div>
    </div>
  );
};

export default FTHPay;
